// utils/arqueoUtils.js
import axios from "axios";
import { API_URL } from "@/config/env";

/**
 * Verifica el estado actual del arqueo en el servidor
 * @returns {Promise<boolean>} true si el arqueo está activo, false si no
 */
export const checkArqueoStatus = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/arqueo/status`);
    return response.data?.isActive || false;
  } catch (error) {
    console.error("Error al verificar estado del arqueo:", error);

    // Fallback: intentar obtener desde localStorage si está disponible
    try {
      const localStatus = localStorage.getItem("arqueoStatus");
      if (localStatus !== null) {
        return JSON.parse(localStatus);
      }
    } catch (e) {
      console.error("Error al leer estado local del arqueo:", e);
    }

    // Por defecto, asumimos que el arqueo no está activo si hay error
    return false;
  }
};

/**
 * Actualiza el estado local del arqueo
 * @param {boolean} isActive Estado del arqueo
 */
export const updateLocalArqueoStatus = (isActive) => {
  try {
    localStorage.setItem("arqueoStatus", JSON.stringify(isActive));
  } catch (error) {
    console.error("Error al guardar estado local del arqueo:", error);
  }
};

/**
 * Suscribe a eventos de cambio de estado del arqueo
 * @param {Function} callback Función a ejecutar cuando cambia el estado
 * @returns {Function} Función para cancelar la suscripción
 */
export const subscribeToArqueoChanges = (callback) => {
  const handleArqueoChange = (event) => {
    if (event.detail && typeof event.detail.isActive === "boolean") {
      // Actualizar estado local
      updateLocalArqueoStatus(event.detail.isActive);
      // Ejecutar callback
      callback(event.detail.isActive);
    }
  };

  window.addEventListener("arqueoStateChanged", handleArqueoChange);

  // Retornar función para cancelar suscripción
  return () => {
    window.removeEventListener("arqueoStateChanged", handleArqueoChange);
  };
};

/**
 * Obtiene el estado actual del arqueo desde el almacenamiento local
 * @returns {boolean} Estado del arqueo (false si no está disponible)
 */
export const getLocalArqueoStatus = () => {
  try {
    const status = localStorage.getItem("arqueoStatus");
    return status ? JSON.parse(status) : false;
  } catch (error) {
    console.error("Error al leer estado local del arqueo:", error);
    return false;
  }
};
